import React, { useEffect, useState } from "react";
import { Heart, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { MonthPicker, lastMonths } from "@/pages/star/MyScore";

export default function DiaryFeedbackPanel() {
  const [month, setMonth] = useState(lastMonths()[0]);
  const [d, setD] = useState(null);
  useEffect(() => { setD(null); api.get("/admin/diary/feedback", { params: { month } }).then((r) => setD(r.data)).catch(() => setD({ items: [] })); }, [month]);
  const likes = d?.items.filter((x) => x.like).length || 0;
  return (
    <div className="space-y-4" data-testid="diary-feedback-panel">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div><h2 className="text-xl font-bold text-slate-900">Parent Feedback (Class Diary)</h2>
          <p className="text-sm text-slate-500">Daily likes and reviews from parents. Only the office sees these — teachers don't.</p></div>
        <MonthPicker value={month} onChange={setMonth} testid="diary-feedback-month" />
      </div>
      {!d ? <Loader2 className="h-5 w-5 animate-spin text-slate-500" /> : (
        <>
          <p className="text-sm text-slate-700" data-testid="diary-feedback-summary"><b>{d.items.length}</b> reviews · <b>{likes}</b> likes</p>
          {d.items.length === 0 && <p className="rounded-xl border border-dashed border-slate-300 p-4 text-sm text-slate-500">No parent feedback this month yet.</p>}
          <div className="space-y-2">
            {d.items.map((x, i) => (
              <div key={i} className="rounded-xl border border-slate-200 bg-white p-3 text-sm" data-testid={`diary-feedback-${i}`}>
                <div className="flex flex-wrap items-center gap-2">
                  {x.like && <Heart className="h-4 w-4 fill-rose-600 text-rose-600" />}
                  <span className="font-semibold text-slate-900">{x.student}</span>
                  <span className="text-xs text-slate-500">{x.roll_number} · {x.student_class} · {x.date}</span>
                  <span className="text-xs text-slate-500">Teacher: {x.teachers.join(", ")}</span>
                </div>
                {x.review && <p className="mt-1 text-slate-700">“{x.review}”</p>}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
